import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./AboutContent.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
// import LeadershipSectionNewCheck from "./LeadershipSectionNewCheck";
import OurLeadsData from "../../data/OurLeadsData.json";
import EmpoweringUnstoppableData from "./EmpoweringUnstoppableData.json";
import ExpertiseData from "./ExpertiseData.json";
import AwardContent from "../AwardFolder/AwardContent";
import { useDispatch, useSelector } from "react-redux";
import { SearchBar } from "../../Pages/Search";
import { onChange } from "../Redux/SearchSlice";

function AboutContent() {

  const dispatch = useDispatch()
     const onMouseClick = () =>{
             dispatch(onChange())
  }
  const selector = useSelector(state=>state.search.value)

  useEffect(() => {
    const handleAOS = () => {
      if (window.innerWidth > 768) {
        AOS.init({ duration: 800 });
      } else {
        AOS.refreshHard();
        document.querySelectorAll("[data-aos]").forEach((el) => {
          el.removeAttribute("data-aos");
        });
      }
    };
    handleAOS();
    window.addEventListener("resize", handleAOS);
    return () => window.removeEventListener("resize", handleAOS);
  }, []);
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
       {selector && selector!==""? <SearchBar/>: <>
      <div className="video-container" id="main">
        <title>L-TT About-LTT</title>
        {/* <h1 class="sr-only" tabIndex={0}>
          About LTT
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/About-Banner-Mobile-New.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/Banners/About-Banner.png"}
          alt="about-banner"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/About-LTT"
            >
              About L&TT
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>About L&TT</h1>
          <p>
            At L&TT, we invest in learning and people development, delivering 20
            million training hours Y-O-Y to equip people with future-ready
            skills. With ~47% of all learning happening through ATCI, it is a
            key hub for enhancing people's expertise and capabilities.
          </p>
        </div>
      </div>
      {/* first section */}
      <div className="our-vis-mis-container vision-container">
        <div className="our-vis-mis-wrap">
          <div className="our-vis-mis-extra-row">
            <div className="our-vis-mis-row row1" data-aos="fade-left">
              <div className="our-vis-mis-box">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/About/our-vision-brand.png"
                  }
                  alt="Empowering Talent"
                  className="our-vis-mis-img"
                />
              </div>
            </div>
            <div className="our-vis-mis-row row2">
              <div className="our-vis-mis-box">
                <h2 className="main-headings">
                  Empowering Talent, Delivering 360° Value{" "}
                </h2>
                <div className="our-vis-mis-divider-row" data-aos="fade-right">
                  <div className="our-vis-mis-divider">
                    <h3>Our Ethos</h3>
                    <p>
                      Learning & Talent Transformation (L&TT) is driven by a
                      future-focused leadership vision, robust business
                      connectedness, in-depth collaboration, and inclusive work
                      culture.
                    </p>
                    <h3>Our Mission</h3>
                    <p>
                      To build world-class talent by fostering continuous
                      learning and developing relevant, future-ready skills.
                    </p>
                  </div>
                  <div className="our-vis-mis-divider">
                    <h3>Innovation</h3>
                    <p>
                      We curate content for internal learning platforms, develop
                      knowledge portals, and establish partnerships with
                      external digital platforms for self-paced learning and
                      certifications.
                    </p>
                    <h3>Compliance</h3>
                    <p>
                      We achieved successful CMMI audits by QAI for application
                      maintenance, support, and testing projects.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* third section */}
      <div className="leadership-container">
        <div className="leadership-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Hear from Our Leadership</h2>
          </div>
          <div className="our-leadership-message-wrap" data-aos="fade-up">
            <div className="our-leadership-message-row row1">
              {/* <img
                src="images/About/top-comment-quote.png"
                alt="quote"
                className="top-comment-quote"
              /> */}
              <p>
                Learning & Talent Transformation (L&TT) powers the massive skill
                transformation of our people, enabling them in digital
                technologies to fulfill a strong demand to build advanced skills
                and lead in today's dynamic business environment.
              </p>
              <p>
                Driving continuous learning at scale, L&TT invests in creating
                and reinventing ATCI talent that is future-ready by establishing
                a responsive learning ecosystem and introducing innovative
                learning approaches across a spectrum of offerings for all
                career levels, aligned to immediate business-specific
                requirements.
              </p>
              <p>
                <span>Join me to experience L&TT right here, right now!</span>
              </p>
            </div>
            <div className="our-leadership-message-row row2">
              <img
                src="images/About/Ambrish-New-Pic.png"
                alt="leaderhip pic"
                className="leadership-pic"
              />
              <div className="leader-detail-box">
                <h3>Ambrish Rastogi</h3>
                {/* <p>Lead – Learning & Leadership Development, ATC-GN</p> */}
                <p>Learning Lead - Reinvention Engine Technology</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* fourth section */}
      <div className="modern-learning-cycle-container">
        <div className="modern-learning-cycle-wrap">
          <div className="modern-learning-cycle-extra-row">
            <div className="modern-learning-cycle-row row1">
              <div className="heading-box">
                <h2 className="main-headings">Modern Ecosystem</h2>
              </div>
              <img
                src="images/About/modern-ecosystem-info-brand.png"
                alt="Modern Ecosystem Info"
                className="info-cycle-img"
                data-aos="fade-left"
              />
            </div>
            <div className="modern-learning-cycle-row row2">
              <div className="heading-box">
                <h2 className="main-headings">Learning Cycle</h2>
              </div>
              <p>
                L&TT continuously collaborates with the business to design,
                implement, and refine learning frameworks and models.{" "}
              </p>
              <img
                src="images/About/learning-cycle-info-brand.png"
                alt="Learning Cycle Info"
                className="info-cycle-img"
                data-aos="fade-right"
              />
            </div>
          </div>
        </div>
      </div>

      {/* new three section */}
      <div className="our-expertise-container" id="Our-Expertise">
        <div className="our-expertise-empowering-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Our Expertise</h2>
          </div>
          <p className="expertise-subtext">
            The L&TT team comprises industry-accredited subject matter experts
            (SMEs), a specialized team of instructional designers, visual
            artists, and programmers, and learning delivery operations experts
            to help build the NexGen skills of ATCI people.
          </p>
          <div className="our-expertise-empowering-extra-row">
            {ExpertiseData.map((item) => {
              return (
                <div
                  key={item.id}
                  className="our-expertise-empowering-row"
                  data-aos="zoom-in-up"
                >
                  <div className="our-expertise-empowering-box">
                    <div className="icon-title-box">
                      <div className="expert-empower-icon-hold">
                        <img
                          src={item.icon}
                          alt="expertise icon"
                          className="expertise-empower-icon"
                        />
                      </div>
                      <h3>{item.title}</h3>
                    </div>
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* new four section */}
      <div className="our-empowering-container">
        <div className="our-expertise-empowering-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Empowering Unstoppable Learning</h2>
          </div>
          <div className="our-expertise-empowering-extra-row">
            {EmpoweringUnstoppableData.map((item) => {
              return (
                <div
                  key={item.id}
                  className="our-expertise-empowering-row"
                  data-aos="zoom-in-up"
                >
                  <div className="our-expertise-empowering-box">
                    <div className="icon-title-box">
                      <div className="expert-empower-icon-hold">
                        <img
                          src={item.icon}
                          alt="empower icon"
                          className="expertise-empower-icon"
                        />
                      </div>
                      <h3>{item.title}</h3>
                    </div>
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* fourth section */}
      <div className="our-leads-container" id="Our-Leads">
        <div className="our-leads-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Our Leads</h2>
          </div>
          <div className="our-leads-extra-row">
            {OurLeadsData.map((item) => {
              return (
                <div
                  key={item.id}
                  className="our-leads-row"
                  data-aos="zoom-in-up"
                >
                  <div className="our-leads-box">
                    <img
                      src={item.image}
                      // alt={item.name}
                      alt="hello"
                      className="profile-pic"
                    />
                    <h3>{item.name}</h3>
                    <p>{item.title}</p>
                    <a
                      href={item.linkedin}
                      className="linkedin-icon-link"
                      target="blank"
                      aria-label="linkedin"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/About/Leads/linkedin-icon.png"
                        }
                        alt={item.name}
                        className="linkedin-icon"
                      />
                    </a>
                    <a
                      href={item.mailid}
                      className="mailid-icon-link"
                      aria-label="mail"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/About/Leads/mailid-icon.png"
                        }
                        alt={item.name}
                        className="mailid-icon"
                      />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* last section */}
      <div className="awards-last-sec" id="Awards">
        <div className="prest-awards-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Prestigious Awards</h2>
          </div>
          <p className="awards-subtext">
            Discover the numerous awards the L&TT team has won for excellence in
            learning and innovation over the years. These honors highlight our
            top-tier learning programs, processes, and strategies, which have
            strengthened the organization’s professional reputation.
          </p>
        </div>
        <AwardContent />
      </div>
      </>}
    </>
  );
}

export default AboutContent;
